module.exports = __webpack_public_path__ + "img/ios-about.07cad0aa.webp";